function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import setupInterceptors from '@/services/setupInterceptors';
import axios from 'axios';
import { loginObj } from '@/services/base';
import tasks from '@/js/tasks';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
var appApisGTW = null;
if (!configuration['chatbot']) {
  appApisGTW = axios.create({
    baseURL: 'http://localhost{PORT}'.replace('{PORT}', ':8093')
  });
} else {
  appApisGTW = axios.create({
    // baseURL: 'https://dev-itcbi-matilliondev-run-usct1-temp-qmuzefzuga-uc.a.run.app'.replace('{PORT}', ':8000')
    baseURL: process.env.VUE_APP_API_GTW.replace('{PORT}', ':8000') //process.env.VUE_APP_CR_CHATBOT_MNGMT //process.env.VUE_APP_API_GTW.replace('{PORT}', ':8000')
  });
}
setupInterceptors(appApisGTW);
var MODULE = '/api/chatbotmngt';
var CONTROLLER = "/metrics";
export default {
  getActivityTime: function () {
    var _getActivityTime = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(data) {
      var response, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            _context.n = 1;
            return appApisGTW.post("".concat(MODULE).concat(CONTROLLER, "/activity-time"), data);
          case 1:
            response = _context.v;
            return _context.a(2, response.data);
          case 2:
            _context.p = 2;
            _t = _context.v;
            console.error('Error:getActivityTime.', _t);
          case 3:
            return _context.a(2);
        }
      }, _callee, null, [[0, 2]]);
    }));
    function getActivityTime(_x) {
      return _getActivityTime.apply(this, arguments);
    }
    return getActivityTime;
  }(),
  getSessions: function () {
    var _getSessions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(data) {
      var response, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            _context2.p = 0;
            _context2.n = 1;
            return appApisGTW.post("".concat(MODULE).concat(CONTROLLER, "/sessions"), data);
          case 1:
            response = _context2.v;
            return _context2.a(2, response.data);
          case 2:
            _context2.p = 2;
            _t2 = _context2.v;
            console.error('Error:getSessions.', _t2);
          case 3:
            return _context2.a(2);
        }
      }, _callee2, null, [[0, 2]]);
    }));
    function getSessions(_x2) {
      return _getSessions.apply(this, arguments);
    }
    return getSessions;
  }(),
  getMessages: function () {
    var _getMessages = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(data) {
      var response, _t3;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            _context3.p = 0;
            _context3.n = 1;
            return appApisGTW.post("".concat(MODULE).concat(CONTROLLER, "/messages"), data);
          case 1:
            response = _context3.v;
            return _context3.a(2, response.data);
          case 2:
            _context3.p = 2;
            _t3 = _context3.v;
            console.error('Error:getMessages.', _t3);
          case 3:
            return _context3.a(2);
        }
      }, _callee3, null, [[0, 2]]);
    }));
    function getMessages(_x3) {
      return _getMessages.apply(this, arguments);
    }
    return getMessages;
  }(),
  getMails: function () {
    var _getMails = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(data) {
      var response, _t4;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            _context4.p = 0;
            _context4.n = 1;
            return appApisGTW.post("".concat(MODULE).concat(CONTROLLER, "/emails"), data);
          case 1:
            response = _context4.v;
            return _context4.a(2, response.data);
          case 2:
            _context4.p = 2;
            _t4 = _context4.v;
            console.error('Error:getMails.', _t4);
          case 3:
            return _context4.a(2);
        }
      }, _callee4, null, [[0, 2]]);
    }));
    function getMails(_x4) {
      return _getMails.apply(this, arguments);
    }
    return getMails;
  }()
};